import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/calculator',
    name: 'Calculator',
    component: () => import('../views/Calculator.vue')
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: () => import('../views/Questionnaire.vue')
  },
  {
    path: '/enroll',
    name: 'Enroll',
    component: () => import('../views/Enroll.vue')
  },
  {
    path: '/enroll_color',
    name: 'EnrollColor',
    component: () => import('../views/EnrollColor.vue')
  },
  {
    path: '/enroll_color2',
    name: 'EnrollColor2',
    component: () => import('../views/EnrollColor2.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
